import { PaginationMetadata } from '@go-shared/types/pagination';
import React, { FC } from 'react';
import { BubbleButton, BubbleSelect } from '@go-client/components/BubbleUI';
import { paginationOptions } from '@go-shared/lib/paginations';
import { mapBy } from '@go-shared/lib/functional';

type BubbleTablePaginationFooterProps = {
  paginationMetadata: PaginationMetadata;
  perPage: number;
  onLoadMoreClick: () => void;
  onPerPageChange: (val: any) => void;
};

export const BubbleTablePaginationFooter: FC<BubbleTablePaginationFooterProps> = ({
  paginationMetadata,
  perPage,
  onLoadMoreClick,
  onPerPageChange,
}) => {
  const { total, current_page, last_page } = paginationMetadata;
  const loadMore = current_page < last_page;

  const paginationOptsDict = mapBy(paginationOptions, 'value');

  let from = 0;
  if (total > 0) {
    from = total < perPage ? total : current_page * perPage;

    if (current_page === last_page) {
      from = total;
    }
  }

  return (
    <div className="grid grid-cols-3 gap-4 items-center w-full p-2">
      <div className="p-2 text-gray-700">
        Showing <b>{from}</b> of <b>{total}</b>
      </div>

      <div className="flex justify-center">
        {loadMore && (
          <BubbleButton
            variant={'navy'}
            inverse
            block
            icon="caret-down"
            iconSuffix="caret-down"
            onClick={onLoadMoreClick}
          >
            Load More
          </BubbleButton>
        )}
      </div>

      <div className="flex justify-end">
        <div className="flex items-center">
          <div className="mr-2">Per page:</div>
          <BubbleSelect
            allowUndefined={false}
            labelExtractor={opt => paginationOptsDict[opt].label}
            value={perPage}
            options={paginationOptions.map(opt => opt.value)}
            onValue={value => onPerPageChange(value)}
          />
        </div>
      </div>
    </div>
  );
};
